import { getMessaging, getToken } from 'firebase/messaging';
import { initializeApp } from 'firebase/app';

import ajax from '@/modules/ajax';

import { currentDomain, isUserSignedIn, metaValue } from '@/modules/helper';

const SAVED_TOKEN_KEY = 'danca:device_token';

const fetchToken = async (registration) => {
  console.log('[firebase] fetchToken...');

  const appId = metaValue('firebase_public_app_id');
  const projectId = metaValue('firebase_public_project_id');

  const config = {
    apiKey: metaValue('firebase_public_api_key'),
    appId: appId,
    authDomain: `${projectId}.firebaseapp.com`,
    measurementId: metaValue('firebase_public_measurement_id'),
    messagingSenderId: metaValue('firebase_public_sender_id'),
    projectId: projectId,
    storageBucket: `${projectId}.appspot.com`,
  };

  const app = initializeApp(config);
  const messaging = getMessaging(app);
  const vapidKey = metaValue('firebase_public_vapid_key');

  try {
    const token = await getToken(messaging, { serviceWorkerRegistration: registration, vapidKey });

    console.log('[firebase] fetchToken!');

    if (token) return token;

    console.log('[firebase] fetchToken no result.');
  } catch (error) {
    console.log('[firebase] fetchToken failed', error);

    throw error;
  }
};

const saveDevice = (token) => {
  console.log('[firebase] saveDevice...');

  try {
    ajax({
      body: { device: { domain: currentDomain(), token, user_agent: navigator.userAgent } },
      done: () => localStorage.setItem(SAVED_TOKEN_KEY, token),
      method: 'POST',
      skipNotify: true,
      url: '/api/devices',
    });

    console.log('[firebase] saveDevice!');
  } catch (error) {
    console.log('[firebase] saveDevice failed', error);

    throw error;
  }
};

export const registerDevice = async () => {
  console.log('[firebase] registerDevice...');

  if (!isUserSignedIn()) return console.log('[firebase] registerDevice! (skipped, not signed in)');

  try {
    const registration = await navigator.serviceWorker.ready;

    const token = await fetchToken(registration);

    if (!token) return console.log('[firebase] registerDevice! (no token)');

    if (token === localStorage.getItem(SAVED_TOKEN_KEY)) {
      return console.log('[firebase] registerDevice! (already saved)');
    }

    saveDevice(token);

    console.log('[firebase] registerDevice!');
  } catch (error) {
    console.log('[firebase] registerDevice failed', error);

    throw error;
  }
};
